import BaseTabs from './Tabs';

// EXPORT
export const Tabs = BaseTabs;
export type { TabsProps } from './Tabs.interface';
